export default __webpack_public_path__ + "static/media/mandala_two.0e78ba24.png";